import React from 'react'
// hooks
import { useDatePicker } from 'hooks/useDatePicker'
// components
import { TimePicker, TimePickerProps } from '@mui/x-date-pickers/TimePicker'

export interface CustomTimePickerProps extends Omit<TimePickerProps<any>, 'onChange' | 'label'> {
  error?: boolean
  label?: string
  onChange: (value: string) => void
  required?: boolean
  dateFormat?: string
}

const TimePickerComponent: React.FC<CustomTimePickerProps> = ({
  value,
  label,
  error,
  required,
  onChange,
  dateFormat,
  ...rest
}) => {
  const { props } = useDatePicker({ value, label, error, required, onChange })

  return (
    <TimePicker
      {...rest}
      {...props}
      ampm={dateFormat?.toLowerCase().includes('a') || false}
      autoFocus={false}
      closeOnSelect={false}
      format={dateFormat || 'HH:mm'}
    />
  )
}

export default TimePickerComponent
